/* Recently viewed — localStorage of handles, cards fetched from
   templates/product.card.liquid via ?view=card. Section stays hidden
   until at least one card renders. */
(function () {
  'use strict';
  var KEY = 'tt-recently-viewed';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* Called from the product template. */
  window.TTRecordView = function (handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list.slice(0, 8));
  };

  function render() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var grid = section.querySelector('[data-recent-grid]');
    var max = parseInt(section.dataset.max, 10) || 3;
    var current = document.body.dataset.productHandle;

    var list = read().filter(function (h) { return h !== current; }).slice(0, max);
    if (!list.length) return;

    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).join('');
      if (!html) return;
      grid.innerHTML = html;
      section.hidden = false;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
